export default class {
    constructor ($translate, lodash, UserResource, CourseVersionResource,
                 CommonService, ModalService, TokenService,
                 OCCURRENCE_STATUS_ENUM, ROLE_CODE_ENUM, COURSE_TRAINING_TYPE_ENUM,
                 COURSE_TRAINING_MATERIAL_TYPE_ENUM, COURSE_TRAINING_PASSING_TYPE_ENUM) {
        this.$translate = $translate;
        this.lodash = lodash;
        this.UserResource = UserResource;
        this.CourseVersionResource = CourseVersionResource;
        this.CommonService = CommonService;
        this.ModalService = ModalService;
        this.OCCURRENCE_STATUS_ENUM = OCCURRENCE_STATUS_ENUM;
        this.ROLE_CODE_ENUM = ROLE_CODE_ENUM;
        this.COURSE_TRAINING_TYPE_ENUM = COURSE_TRAINING_TYPE_ENUM;
        this.COURSE_TRAINING_MATERIAL_TYPE_ENUM = COURSE_TRAINING_MATERIAL_TYPE_ENUM;
        this.defaultLanguage = TokenService.getCompanyLanguage();
        this.COURSE_TRAINING_PASSING_TYPE_ENUM = COURSE_TRAINING_PASSING_TYPE_ENUM;
    }

    hasRequiredTrainings (courseTrainings) {
        if (!courseTrainings) {
            return 0;
        }
        return courseTrainings.filter(
            (training) => training.passingType !== this.COURSE_TRAINING_PASSING_TYPE_ENUM.KEYS.OPTIONAL
        ).length;
    }

    nestCompositeModels (version) {
        this.CommonService.nestModel(version, 'courseTrainingI18ns', 'courseTrainings', 'trainingId', 'id', 'language');
        this.CommonService.nestModel(version, 'courseTrainingForms', 'courseTrainings', 'trainingId', 'id');
    }

    getPublishedOccurrenceCount (version) {
        return this.getOccurrenceCountByStatuses(version, [this.OCCURRENCE_STATUS_ENUM.KEYS.PUBLISHED]);
    }

    getUnpublishedCancelledOccurrenceCount (version) {
        return this.getOccurrenceCountByStatuses(version, [
            this.OCCURRENCE_STATUS_ENUM.KEYS.UNPUBLISHED,
            this.OCCURRENCE_STATUS_ENUM.KEYS.CANCELLED
        ]);
    }

    getOccurrenceCountByStatuses (version, statuses) {
        if (!this.lodash.has(version, 'courseOccurrences')) {
            return 0;
        }
        return version.courseOccurrences.filter((item) => {
            return statuses.indexOf(item.status) !== -1;
        }).length;
    }

    getWarningMessage (version) {
        const count = this.getPublishedOccurrenceCount(version);
        const unpublishedCancelledCount = this.getUnpublishedCancelledOccurrenceCount(version);
        if (count) {
            return this.$translate.instant('version.alias.published_occurrences', { count });
        }
        else if (unpublishedCancelledCount) {
            return this.$translate.instant('version.alias.unpublished_occurrences', { count: unpublishedCancelledCount });
        }
        return '';
    }

    getDuration (duration) {
        return this.$translate.instant('{n, plural, one {# hour} other {# hours}}', { n: duration });
    }

    getWithoutPlanningUserCount (courseVersion) {
        return this.UserResource.query({
            drlCourseId: courseVersion.courseId,
            excludeInActiveUsers: true,
            roleCode: this.ROLE_CODE_ENUM.KEYS.EMPLOYEE,
            pageSize: 0
        }).$promise
            .then((users) => {
                return users.length;
            });
    }

    getTrainingImageUrl (training, companyId, thumbnailDir) {
        let baseUrl = `${SEED_CORE.ENV.API_URL}courseTrainingImages/${companyId}/${training.id}`;
        if (thumbnailDir) {
            baseUrl = `${baseUrl}/thumbnails/${thumbnailDir}`;
        }
        return `${baseUrl}/${training.imageFilename}`;
    }

    getOnlineTrainingsWoMaterials (courseTrainings) {
        if (!courseTrainings) {
            return [];
        }
        return courseTrainings.filter(training => {
            return training.type === this.COURSE_TRAINING_TYPE_ENUM.KEYS.ONLINE
                && !training.learndashCourseId
                && training.materialType === this.COURSE_TRAINING_MATERIAL_TYPE_ENUM.KEYS.LEARNDASH;
        });
    }

    /**
     * This method map randomized form selection under "formids"
     * Used in version API beforeSave
     */
    mapTrainingForms (trainings) {
        this.lodash.map(trainings, (training, index) => {
            training.index = index;
            if (training.forms) {
                training.formIds = training.forms.map(form => form.id);
            }
            else if (training.courseTrainingForms) {
                training.formIds = training.courseTrainingForms.map(form => form.formId);
            }
            if (!training.isFormRandomized) {
                training.formIds = [];
            }
            if (training.type !== this.COURSE_TRAINING_TYPE_ENUM.KEYS.FEEDBACK) {
                delete training.courseTrainingI18ns[this.defaultLanguage].feedbackTitle;
                delete training.courseTrainingI18ns[this.defaultLanguage].feedbackIntroduction;
            }
            if (training.type !== this.COURSE_TRAINING_TYPE_ENUM.KEYS.FEEDBACK
                && training.type !== this.COURSE_TRAINING_TYPE_ENUM.KEYS.TEST) {
                delete training.formId;
            }
            if (training.type === this.COURSE_TRAINING_TYPE_ENUM.KEYS.FEEDBACK) {
                delete training.materialType;
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/services/course/version/index.js